import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import backicon from "../../../../../../Assets/icons/backIcon.svg"

const WarrantyCheckDetailsAdmin = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const dataValues = location?.state?.data;
  console.log(dataValues, "dataValues")

  return (
    <>
    <div className='OnboardManagamentContainer'>
      <div className='OnboardManagamentbuttonContainer'>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">
        {
            dataValues.warrantyType === "Dealer Side" ? <h4>Dealer Purchase Order Details</h4> : <h4>Customer Purchase Order Details</h4>
        }</span>
          </div>
        
      </div>
      <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>

      </div>
    </div>

    {/* Order Details Section */}
    {/* <h5 className="mt-2 mb-2 ">Order Details</h5> */}
    <div className="details-section">
     
      <div className="detail-grid">
        <div className="details-item">
          <span className="details-label">Full Name</span>
          <span className="details-value">{dataValues?.full_name}</span>
        </div>
        <div className="details-item">
          <span className="details-label">Customer Delivery Date</span>
          <span className="details-value">{dataValues?.customer_delivery_date}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Mobile</span>
          <span className="details-value">{dataValues?.mobile_no}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Customer Email Id</span>
          <span className="details-value">{dataValues?.email_id}</span>
        </div>


        
      </div>
         <h3 className="mt-5 mb-2  ">Vehicle Warranty</h3>

         <div className="detail-grid">
        <div className="details-item">
          <span className="details-label">Vin No</span>
          <span className="details-value">{dataValues?.vin_no ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Chasis No.</span>
          <span className="details-value">{dataValues?.chassis_no ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Motor No.</span>
          <span className="details-value">{dataValues?.motor_no ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Battery No.</span>
          <span className="details-value">{dataValues?.battery_no ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Vehicle Warranty From</span>
          <span className="details-value">{dataValues?.warrantyFrom ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Vehicle Warranty To</span>
          <span className="details-value">{dataValues?.warrantyTo ?? "-"}</span>
        </div>

         </div>

         <h3 className="mt-5 mb-2  ">Battery Warranty</h3>

         <div className="detail-grid">
         <div className="details-item">
          <span className="details-label">Battery No.</span>
          <span className="details-value">{dataValues?.battery_no ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Battery Remaining Days</span>
          <span className="details-value">{dataValues?.btryremaining_days ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Battery Warranty From</span>
          <span className="details-value">{dataValues?.batteryWarrntyFrom ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Battery Warranty To</span>
          <span className="details-value">{dataValues?.batteryWarrntyTo ?? "-"}</span>
        </div>

         </div>

         <h3 className="mt-5 mb-2  ">Controller Warranty</h3>

         <div className="detail-grid">
        <div className="details-item">
          <span className="details-label">Controller Warranty From</span>
          <span className="details-value">{dataValues?.cntrlwarrantyFrom ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Controller Warranty To</span>
          <span className="details-value">{dataValues?.cntrlwarrantyTo ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Controller Remaining Days</span>
          <span className="details-value">{dataValues?.cntrlremaining_days ?? "-"}</span>
        </div>

         </div>


         <h3 className="mt-5 mb-2  ">Motor Warranty</h3>

         <div className="detail-grid">
         <div className="details-item">
          <span className="details-label">Motor No</span>
          <span className="details-value">{dataValues?.motor_no ?? "-"}</span>
        </div>
        <div className="details-item">
          <span className="details-label">Motor Warranty From</span>
          <span className="details-value">{dataValues?.mtrwarrantyFrom ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Motor Warranty To</span>
          <span className="details-value">{dataValues?.mtrwarrantyTo ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Motor Remaining Days</span>
          <span className="details-value">{dataValues?.mtrremaining_days ?? "-"}</span>
        </div>

         </div>

         <h3 className="mt-5 mb-2  ">Charger Warranty</h3>

         <div className="detail-grid">
        <div className="details-item">
          <span className="details-label">Charger Warranty From</span>
          <span className="details-value">{dataValues?.chrgrwarrantyFrom ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Charger Warranty To</span>
          <span className="details-value">{dataValues?.chrgrwarrantyTo ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Charger Remaining Days</span>
          <span className="details-value">{dataValues?.chrgrremaining_days ?? "-"}</span>
        </div>

         </div>

         <h3 className="mt-5 mb-2  ">Converter Warranty</h3>

         <div className="detail-grid">
        <div className="details-item">
          <span className="details-label">Converter Warranty From</span>
          <span className="details-value">{dataValues?.covrtwarrantyFrom ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Converter Warranty To</span>
          <span className="details-value">{dataValues?.covrtwarrantyTo ?? "-"}</span>
        </div>

        <div className="details-item">
          <span className="details-label">Converter Remaining Days</span>
          <span className="details-value">{dataValues?.covrtremaining_days ?? "-"}</span>
        </div>

         </div>

    </div>
  </>
  );
};

export default WarrantyCheckDetailsAdmin;

